type PageLayoutHeaderProps = { children: React.ReactNode; className?: string }
export function PageLayoutCustomHeader({ children, className }: Readonly<PageLayoutHeaderProps>) {
  return (
    <div className={'PageLayoutCustomHeader ' + className}>
      <div className="PageLayoutCustomHeader__content">{children}</div>
    </div>
  )
}
